<template>
  <div name="housingResource" class="housingResource">
    <div class="header">
      <span :title="query.housingEstateName">
        小区名称:
        <span class="name">{{query.housingEstateName}}</span>
      </span>
      <div class="explain">
        <div class="div border"></div>
        <span>可选</span>
      </div>
      <!-- <div class="explain">
        <div class="div false"></div>
        <span>不可选</span>
      </div> -->
      <div class="explain">
        <div class="div success"></div>
        <span>已被选</span>
      </div>

      <el-button size="small" round style="margin-left:20px" type="primary" v-popover:popover>
        条件筛选
        <span class="icon icon-shaixuan"></span>
      </el-button>

      <el-popover ref="popover" placement="bottom" title="房源筛选" width="500" trigger="click" :value="popShowDisable" @show="handlePopShow">
        <div class="popover-box">
          <!-- <div class="popover-box-item">
            <div style="marginBottom:10px">房源范围</div>
            <div>
              <el-button :type="forTheMomentFlag ? 'primary' : ''" size="small" @click="handleOnUseHouseFlag">全部房源</el-button>
              <el-button :type="!forTheMomentFlag ? 'primary' : ''" size="small" @click="handleOffUseHouseFlag">可选房源</el-button>
            </div>
          </div> -->
          <div class="popover-box-item">
            <div style="marginBottom:10px">面积范围</div>
            <div>
              <el-input-number :precision="2" :step="0.01" :min="0" v-model="startArea" placeholder="最低" style="width:150px;marginRight:5px" size="small" :controls="false"></el-input-number>
              <span>—</span>
              <el-input-number :precision="2" :step="0.01" :min="0" v-model="endArea" placeholder="最高" style="width:150px;marginLeft:5px" size="small" :controls="false"></el-input-number>
            </div>
          </div>
          <div class="popover-box-item" v-if="houseBtnList.length > 0">
            <div>户型范围</div>
            <div>
              <el-button v-for="item in houseBtnList" :key="item.id" :type="item.isUse ? 'primary' : ''" size="small" @click="handleClickIsUse(item)" style="margin:10px;marginLeft:0px">
                <div>{{item.houseType}}</div>
                <div style="margin-top: 5px;">{{item.howBedroom}}</div>
              </el-button>
            </div>
          </div>
        </div>
        <div class="popover-footer">
          <div class="footer-reset" @click="handleReset">重置</div>
          <div class="footer-sure" @click="handleSeek">确定</div>
        </div>
      </el-popover>
      <!-- <div class="personal-box-btn-housingResource" v-if="hasBtn">
        <el-dropdown trigger="click">
          <el-button type="primary" size="mini">更多产权信息</el-button>
          <el-dropdown-menu slot="dropdown" style="max-height: 400px;overflow: auto;">
            <el-dropdown-item v-for="(item,index) in fileInformationList" :key="index">
              <div @click="selectFileNumber(item)">
                <span>档案号：</span>
                <span>{{item.householdCode}}</span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div> -->
    </div>
    <div class="housingResourceBody">
      <div class="bodyLeft" v-loading="treeLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <el-tree :default-expanded-keys="defaultKeys" :current-node-key="activeUnitId" ref="unittree" :data="unitTree" :highlightCurrent="true" accordion @node-click="changeUnit" node-key="id" :render-content="renderContent"></el-tree>
      </div>
      <div class="bodyRight">
        <ul class="wrapper" v-show="houseInfo.length > 0">
          <li class="floorInfo" v-for="(floor, floorIndex) in houseInfo" :key="floor.flootKey + 'floor'">
            <div v-show="isEmpty && floorIndex === 0" class="floor-is-empty">
              <None />
            </div>
            <div class="floor-area" v-show="floor.flootHouses.length > 0">
              <div class="floor-num">{{floor.flootKey}}楼</div>
              <div class="house-content">
                <!-- <div class="border canClick" :class="{checked: house.checked}" v-for="house in floor.flootHouses" :key="house.houseNumber" @click="checkHouseInfo(house,house.checked)"> -->
                <div class="canClick" :class="house.status === 5 ? 'unselect' : ''" :style="machineStatusStyle(house.status)" v-for="house in floor.flootHouses" :key="house.houseNumber + 'house'" @click="checkHouseInfo(house,house.checked)">
                  <div class="houseNumber">{{house.houseNumber}}</div>
                  <div class="houseNumber">{{house.houseType}}</div>
                  <div class="houseNumber">{{house.buildingArea}}m²</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div style="height:80%" v-show="houseInfo.length === 0">
          <None />
        </div>
      </div>
    </div>
    <el-dialog width="550px" :title="query.housingEstateName" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogToggle">
      <div class="houseInfo-content">
        <el-row :gutter="10">
          <el-col :span="12" v-for="item in dialogContent" :key="item.key">
            <p class="house-info-p">{{item.label}}：{{item.value}}</p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-for="item in imgs" :key="item.id">
            <img :src="item.imgPreviewURL" alt class="house-type-img" />
          </el-col>
        </el-row>
        <p style="font-size: 14px; line-height: 25px;color: red; margin-top: 10px;" v-show="!hasPermission">
          温馨提示:
          <br />当前剩余可选安置房面积不足以选择该房。
          <br />可先将已选房源进行移除，再进行选房。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" v-show="hasPermission" @click="handleClose">关闭</el-button>
        <!-- <el-button size="small" type="primary" @click="handleChooseRoom" v-show="showAdd && hasPermission">选择该房</el-button> -->
      </span>
    </el-dialog>
    <el-dialog width="550px" title="温馨提醒" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="chooseToSubmitFlag">
      <div v-loading="chooseToSubmitLoading" element-loading-text="提交中" element-loading-spinner="el-icon-loading" element-loading-background="#ffffff">
        <div class="choose-div-box">
          <div class="choose-div-child child-blue" @click="e => handleOldChoose(e, 'old')">
            <span>提交</span>
            <span>并完成选房</span>
          </div>
          <div class="choose-div-child child-orange" @click="e => handleOldChoose(e, 'new')">
            <span>先提交</span>
            <span>再选其他房源</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="chooseToSubmitFlag = false" :disabled="chooseToSubmitLoading">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/javascript" src="/service/report/jquery.min.js"></script>
<script type='text/babel'>
import None from '@/components/none.vue';
import {
  getHousingBuildingUnitTree,
  queryHousingHouseOfFloorByZh,
  saveSelectedHouse,
  queryHouseholdIndex,
  getFileInformationList,
  queryHouseholdSelectHouseList,
  getHousingHouseNumber,
  queryVerifyHousingHouseData
} from '@/api/xian-publicinquiry.api.js';
import { getSession, decodeURI, isUndef, setSession, removeSession } from '@/untils';
import { subtract, addition } from '@/untils/math';
export default {
  name: 'housingResource',
  components: {
    None
  },
  watch: {
    house: {
      deep: true,
      immediate: true,
      handler(val) {
        this.currentHouse = val;
      }
    },
    houseId: {
      deep: true,
      immediate: true,
      handler(val) {
        this.currentId = val;
      }
    },
    houseIdItem: {
      deep: true,
      immediate: true,
      handler(val) {
        this.currentTypeId = val;
      }
    }
  },
  props: {
    houseId: {
      type: String
    },
    house: {
      type: Object
    },
    houseIdItem: { type: String },
    selectedLength: [Number, String],
    selectedArea: [Number, String],
    optionalResettlementTotalArea: [Number, String],
    selectHouseMaxCount: [Number, String],
    isOverflow: {
      type: Boolean,
      default: false
    },
    selectedData: [Array],
    totalhouseTypeList: {
      default: []
    },
    householdTableData: [Array],
    selectedTierBuildingHousingArea: [Number, String]
  },
  computed: {
    selectFlag() {
      let flag = isUndef(getSession('selectFlag')) ? '-1' : getSession('selectFlag');
      return flag;
    },
    tierBuildingHouseIds() {
      let flag = isUndef(getSession('tierBuildingHouseIds')) ? [] : getSession('tierBuildingHouseIds');
      return flag;
    },
    highBuildingHouseIds() {
      let flag = isUndef(getSession('highBuildingHouseIds')) ? [] : getSession('highBuildingHouseIds');
      return flag;
    },
    hasPermission() {
      let flag = '0';
      if (this.switchResettlementUpperlimit === 1) {
        flag = this.isOverflow || subtract(Number(this.houseData.buildingArea), Number(this.optionalResettlementTotalArea)) > 0 || subtract(addition(Number(this.houseData.buildingArea), Number(this.selectedArea)), Number(this.optionalResettlementTotalArea)) > 0 ? '1' : '0';
      };
      return flag === '0';
    },
    propertyOwner() {
      if (this.userInfo.propertyOwner) {
        return this.userInfo.propertyOwner.length > 10 ? this.userInfo.propertyOwner.substring(0, 10) + '...' : this.userInfo.propertyOwner;
      } else {
        return this.userInfo.propertyOwner;
      }
    },
    housingEstateName() {
      return this.query.housingEstateName.length > 10 ? this.query.housingEstateName.substring(0, 10) + '...' : this.query.housingEstateName;
    },
    hasBtn() {
      return this.fileInformationList.length > 1;
    },

  },
  data() {
    const { query } = this.$route;
    return {
      flag: false,
      currentId: '',
      currentHouse: '',
      currentTypeId: '',
      query,
      unitTree: [],
      houseInfo: [],
      activeHouse: '',
      dialogToggle: false,
      dialogContentConfig: [
        { label: '楼栋', key: 'buildingName' },
        { label: '单元', key: 'unitName' },
        { label: '楼层', key: 'floor' },
        { label: '房号', key: 'houseNumber' },
        { label: '户型', key: 'houseType' },
        { label: '居室', key: 'howBedroom' },
        { label: '朝向', key: 'houseTowards' },
        { label: '建筑面积(m²)', key: 'buildingArea' },
        // { label: '平方单价(元)', key: 'price' },
        // { label: '楼层差价(元)', key: 'floorPrice' },
        // { label: '户型结构', key: 'houseStructName' },
        { label: '套内面积(m²)', key: 'innerArea' },
        { label: '公摊面积(m²)', key: 'sharedArea' },
        { label: '阁楼面积(m²)', key: 'loftArea' },
        { label: '车棚面积(m²)', key: 'carportArea' }
        // { label: '价值总额(元)', key: 'amount' },
        // { label: '备注', key: 'remark' }
      ],
      dialogContent: [],
      projectId: '',
      selectedIds: [], // 已经选择的房源信息
      householdId: '',
      isSelectHouse: '', //分户是否可以在线选房
      fileInformationList: [],
      userInfo: {},
      showAdd: false,
      currentNode: null,
      defaultKeys: [],
      activeUnitId: '',
      houseData: {},
      imgs: [],
      switchResettlementUpperlimit: 0,
      useHouseFlag: true,
      isEmpty: false,
      chooseToSubmitFlag: false,
      chooseToSubmitLoading: false,
      startArea: undefined,
      endArea: undefined,
      houseBtnList: [],
      popShowDisable: false,
      treeLoading: false,
      dataLoading: false,
      temporaryQuery: {},
      forTheMomentFlag: true,
      selectHouseTypeIdArr: [],
      // selectFlag: '-1',
      // tierBuildingHouseIds: [],
      // highBuildingHouseIds: []
    };
  },
  created() {
    // this.currentNode = getSession('node') || null;
    this.projectId = getSession('projectId');
    // this.queryHouseholdIndex();
    this.getUnitTree();
    // this.getFileInformationList();
  },

  beforeDestroy() {
    removeSession('onlySeekSelect')
  },

  methods: {
    machineStatusStyle(status) {
      if (status === 2 || status === 3 || status === 4) {
        return {
          border: 'none',
          background: '#377e22',
          color: '#fff'
        }
      } else if (status === 5) {
        return {
          border: 'none',
          background: '#999999',
          color: '#fff'
        }
      }
    },
    getUnitTree(params = {}) {
      this.treeLoading = true
      this.dataLoading = true
      const { id } = this.query;
      getHousingBuildingUnitTree(this.projectId, id, params).then(res => {
        if (res.code === 0) {
          const data = res.body;
          const result = [];
          data.forEach(item => {
            if (item.isUnit === '0') {
              item.label = item.name;
              item.usableHousingNum = item.usableHousingNum
              item.children = [];
              result.push(item);
            } else {
              item.label = item.name;
              item.usableHousingNum = item.usableHousingNum
              result.filter(p => p.id === item.pid)[0].children.push(item);
            }
          });
          if (this.currentNode) {
            if (Array.isArray(result)) {
              // const unit = this.unitTree.filter(item => item.id === this.currentNode.pid )[0] || {};
              const unitChild = this.currentNode || {};
              const isNullUnitChild = unitChild.id === '-1' ? unitChild.id + unitChild.pid : unitChild.id
              this.defaultKeys = [unitChild.pid, isNullUnitChild];
              if (unitChild.pid && isNullUnitChild) {
                this.$nextTick(() => {
                  this.$refs.unittree.setCurrentKey(isNullUnitChild);
                  this.activeUnitId = isNullUnitChild;
                });
                // this.getHousingHouseOfFloor();
              }
            }
            const arr = []
            result.forEach(item => {
              item.children.forEach(items => {
                if (items.id === '-1') {
                  items.id = items.id + items.pid
                }
              })
              arr.push(item)
            })
            this.unitTree = arr;
            if (result.length) {
              this.getHouseInfo({ pid: this.currentNode.pid, id: this.currentNode.id, isUnit: this.currentNode.isUnit }, params);
            }
            this.treeLoading = false
          } else {
            if (Array.isArray(result)) {
              const unit = result[0] || {};
              const unitChild = unit.children[0] || {};
              const isNullUnitChild = unitChild.id === '-1' ? unitChild.id + unit.id : unitChild.id
              this.defaultKeys = [unit.id, isNullUnitChild];
              if (unit.id && isNullUnitChild) {
                this.$nextTick(() => {
                  this.$refs.unittree.setCurrentKey(isNullUnitChild);
                  this.activeUnitId = isNullUnitChild;
                });
                // this.getHousingHouseOfFloor();
              }
            }
            const arr = []
            result.forEach(item => {
              item.children.forEach(items => {
                if (items.id === '-1') {
                  items.id = items.id + items.pid
                }
              })
              arr.push(item)
            })
            this.unitTree = arr;
            this.currentNode = result[0].children[0];
            if (result.length) {
              this.getHouseInfo(result[0].children[0], params);
            }
          }
          this.treeLoading = false
        } else {
          this.treeLoading = false
          this.$message({
            message: res.errMsg,
            type: 'warning'
          });
        }
      });
    },
    getHouseInfo(item, data) {
      if (item.isUnit === '1') {
        const { id, pid } = item;
        const str = id.indexOf("-") !== -1 ? '-1' : id
        const params = {
          householdId: -1,
          buildingId: pid,
          unitId: str,
          housingEstateId: this.query.id,
          selectHouseType: this.userInfo.selectHouseType,
          ...data
        };
        this.dataLoading = true
        this.houseInfo = []
        queryHousingHouseOfFloorByZh(this.projectId, params).then(res => {
          if (res.code === 0) {
            this.dataLoading = false
            const data = res.body;
            this.houseInfo = data.sort((a, b) => a.flootKey - b.flootKey);
            this.houseInfo.forEach(floor => {
              floor.flootHouses.forEach(item => {
                if (item.status === 1) {
                  item.checked = false;
                } else {
                  item.checked = true;
                }
                this.selectedData.forEach(items => {
                  if (item.id === items.id) {
                    item.status = 2;
                  };
                });
              });
            });
            this.isEmpty = false
            if (!this.useHouseFlag) {
              this.houseInfo.forEach(item => item.flootHouses = item.flootHouses.filter(item => !(item.status === 2 || item.status === 3 || item.status === 4)))
              this.isEmpty = this.houseInfo.every(item => item.flootHouses.length === 0)
            }
          } else {
            this.dataLoading = false
            this.$message({
              message: res.errMsg,
              type: 'warning'
            });
          }
        });
      }
    },
    changeUnit(data) {
      this.popShowDisable = false
      if (data.isUnit === '1') {
        this.currentNode = data;
      }
      setSession('node', data);
      this.getHouseInfo(data, this.temporaryQuery);
    },
    handleClose() {
      this.dialogToggle = false;
    },

    handleChoose() {
      const list = getSession('houseList');
      if (list && list.length > 0) {
        this.chooseToSubmitFlag = true;
      } else {
        this.$message.warning('请选房!');
      }
    },

    handleOldChoose(e, flag) {
      this.chooseToSubmitLoading = true;
      const list = getSession('houseList');
      const ids = list.map(item => item.id);
      let params = { houseIds: ids, isChoose: flag === 'new' ? 2 : 1 };
      saveSelectedHouse(this.projectId, this.householdId, params).then(res => {
        if (res.code === 0) {
          this.chooseToSubmitFlag = false;
          this.chooseToSubmitLoading = false;
          // this.getHouseInfo(this.currentNode, this.temporaryQuery);
          // this.queryHouseholdIndex();
          this.$emit('change');
          this.$message({
            type: 'success',
            message: '选房成功!'
          });
          this.getUnitTree(this.temporaryQuery);
        } else {
          this.chooseToSubmitFlag = false;
          this.chooseToSubmitLoading = false;
          this.$message({
            message: res.errMsg,
            type: 'warning'
          });
        }
      });
    },

    removeHouse() {
      // let selectedAreaNum = addition(Number(this.selectedArea), Number(this.houseData.buildingArea));
      if (this.userInfo.selectHouseType === 1 || this.userInfo.selectHouseType === 4) {
        const houseTableData = this.$props.householdTableData;
        houseTableData.forEach(item => {
          if (item.orgTaoTypeId === this.currentTypeId) {
            if (item.selectHouseNum > 0) {
              item.selectHouseNum = item.selectHouseNum - 1;
            }
          }
        });
        this.$emit('addTableHouseNum', houseTableData);
        if (this.selectHouseTypeIdArr.length > 0) {
          for (var i = 0; i < this.selectHouseTypeIdArr.length; i++) {
            if (this.selectHouseTypeIdArr[i] === this.currentTypeId) {
              this.selectHouseTypeIdArr.splice(i, 1)
              i -= 1;
            }
          }
          // this.selectHouseTypeIdArr.forEach(idItem => {
          //   if (idItem === this.currentTypeId) {
          //     this.selectHouseTypeIdArr.remove(idItem);
          //   }
          // });
        }
      }
      if (this.userInfo.selectHouseType === 5) {
        let houseTableData = this.$props.householdTableData;
        // houseTableData
        if (this.currentHouse.housingAttribute === '212') {
          houseTableData[2].selectHouseNum = subtract(Number(houseTableData[2].selectHouseNum), Number(this.currentHouse.buildingArea));
          houseTableData[2].residualArea = subtract(Number(houseTableData[2].resettlementNum), Number(houseTableData[2].selectHouseNum));
        } else {
          if (this.currentHouse.buildingProperty == 1) {
            houseTableData[0].selectHouseNum = subtract(Number(houseTableData[0].selectHouseNum), Number(this.currentHouse.buildingArea));
            houseTableData[0].residualArea = subtract(Number(houseTableData[0].resettlementNum), Number(houseTableData[0].selectHouseNum));
          } else {
            houseTableData[1].selectHouseNum = subtract(Number(houseTableData[1].selectHouseNum), Number(this.currentHouse.buildingArea));
            houseTableData[1].residualArea = subtract(Number(houseTableData[1].resettlementNum), Number(houseTableData[1].selectHouseNum));
          };
        };
        this.$emit('addTableHouseNum', houseTableData);
      };
      this.houseInfo.forEach(floor => {
        floor.flootHouses.forEach(item => {
          if (item.id === this.currentId && item.status === 2) {
            // debugger
            item.checked = false;
            item.status = 1;
          } else {
            let flag = '0';
            if (this.switchResettlementUpperlimit === 1) {
              flag = subtract(this.selectedArea, this.optionalResettlementTotalArea) >= 0 || subtract(Number(item.buildingArea), Number(this.optionalResettlementTotalArea)) > 0 || subtract(addition(Number(item.buildingArea), Number(this.selectedArea)), Number(this.optionalResettlementTotalArea)) > 0 ? '1' : '0';
              if (item.status === 5) {
                item.status = flag === '0' ? 1 : 5;
              };
            };
            // debugger
            if (item.status === 5) {
              if (this.userInfo.selectHouseType === 1 || this.userInfo.selectHouseType === 4) {
                if (item.orgTaoTypeId === this.currentTypeId) {
                  item.status = 1;
                }
                // if (this.selectHouseTypeIdArr.length>0) {
                // this.selectHouseTypeIdArr.forEach(idItem => {
                //   if (idItem.orgTaoTypeId === item.orgTaoTypeId) {
                //     item.status = 5;
                //   }
                // });
                // }
              };
              if (this.userInfo.selectHouseType === 5) {
                item.status = 1;
                if (this.userInfo.tierBuildingResettlementCompensationArea < 45 && item.buildingProperty === 1 && item.housingAttribute !== '212') item.status = 5;
                if (this.userInfo.highBuildingResettlementCompensationArea < 45 && item.buildingProperty === 2 && item.housingAttribute !== '212') item.status = 5;
                if (item.status === 1 && (this.userInfo.selectedTierBuildingHousingArea === 0 || this.userInfo.selectedTierBuildingHousingArea === '' || this.userInfo.selectedTierBuildingHousingArea === null) && (item.buildingProperty != 1 || item.housingAttribute === '212')) item.status = 5;
                if (item.buildingProperty == 1 && item.housingAttribute !== '212') {
                  if (floor.tierBuildingHouseIds.length === 0) {
                    item.status = 5;
                  } else {
                    if (floor.tierBuildingHouseIds.indexOf(item.id) === -1) item.status = 5;
                  };
                };
                if (item.buildingProperty == 2 && item.housingAttribute !== '212') {
                  if (floor.highBuildingHouseIds.length === 0) {
                    item.status = 5;
                  } else {
                    if (floor.highBuildingHouseIds.indexOf(item.id) === -1) item.status = 5;
                  };
                };
                const houseTableData = this.$props.householdTableData;
                if (Number(houseTableData[2].selectHouseNum) > 0 && item.housingAttribute === '212') item.status = 5;
                if (item.housingAttribute !== '212' && item.buildingProperty === 1) {
                  if (Number(houseTableData[0].residualArea) < 45) item.status = 5;
                };
                if (item.housingAttribute !== '212' && item.buildingProperty === 2) {
                  if (Number(houseTableData[1].residualArea) < 45) item.status = 5;
                };
                if (this.selectedData.length > 0) {
                  this.selectedData.forEach(items => {
                    if (item.id === items.id) {
                      item.status = 2;
                    };
                  });
                };
              }
            }
          };
        });
      });
    },
    handleChooseRoom() {
      if (this.switchResettlementUpperlimit === 1 && this.selectHouseMaxCount !== '' && this.selectedLength + 1 > Number(this.selectHouseMaxCount)) {
        this.$message.warning('已超出选房套数上限!');
      } else {
        this.$emit('add', this.houseData);
        let selectedAreaNum = addition(Number(this.selectedArea), Number(this.houseData.buildingArea));
        if (this.userInfo.selectHouseType === 1 || this.userInfo.selectHouseType === 4) {
          const houseTableData = this.$props.householdTableData;
          houseTableData.forEach(item => {
            if (item.orgTaoTypeId === this.houseData.orgTaoTypeId) {
              item.selectHouseNum = item.selectHouseNum + 1;
              if (item.selectNum - item.selectHouseNum == 0) {
                this.selectHouseTypeIdArr.push(item.orgTaoTypeId);
              }
            }
          });
          this.$emit('addTableHouseNum', houseTableData);
        }
        if (this.userInfo.selectHouseType === 5) {
          const houseTableData = this.$props.householdTableData;
          // houseTableData
          if (this.houseData.housingAttribute === '212') {
            houseTableData[2].selectHouseNum = addition(Number(houseTableData[2].selectHouseNum), Number(this.houseData.buildingArea));
            houseTableData[2].residualArea = subtract(Number(houseTableData[2].resettlementNum), Number(houseTableData[2].selectHouseNum));
          } else {
            if (this.houseData.buildingProperty == 1) {
              houseTableData[0].selectHouseNum = addition(Number(houseTableData[0].selectHouseNum), Number(this.houseData.buildingArea));
              houseTableData[0].residualArea = subtract(Number(houseTableData[0].resettlementNum), Number(houseTableData[0].selectHouseNum));
            } else {
              houseTableData[1].selectHouseNum = addition(Number(houseTableData[1].selectHouseNum), Number(this.houseData.buildingArea));
              houseTableData[1].residualArea = subtract(Number(houseTableData[1].resettlementNum), Number(houseTableData[1].selectHouseNum));
            };
          };
          let data = {
            householdId: this.householdId,
            tierBuildingResidualArea: houseTableData[0].residualArea,
            highBuildingResidualArea: houseTableData[1].residualArea,
          };
          queryVerifyHousingHouseData(this.projectId, data).then(res => {
            setSession('tierBuildingHouseIds', res.body.tierBuildingHouseIds);
            setSession('highBuildingHouseIds', res.body.highBuildingHouseIds);
            setSession('selectFlag', '1');
            // this.highBuildingHouseIds = res.body.highBuildingHouseIds;
            // this.tierBuildingHouseIds = res.body.tierBuildingHouseIds;
            // this.selectFlag = '1';
          });
          this.$emit('addTableHouseNum', houseTableData);
        }
        this.houseInfo.forEach(floor => {
          floor.flootHouses.forEach(item => {
            if (item.id === this.houseData.id) {
              item.checked = true;
              item.status = 2;
            } else {
              let flag = '0';
              if (this.switchResettlementUpperlimit === 1) {
                flag = subtract(selectedAreaNum, this.optionalResettlementTotalArea) >= 0 || subtract(Number(item.buildingArea), Number(this.optionalResettlementTotalArea)) > 0 || subtract(addition(Number(item.buildingArea), Number(selectedAreaNum)), Number(this.optionalResettlementTotalArea)) > 0 ? '1' : '0';
                if (item.status === 1) {
                  item.status = flag === '0' ? 1 : 5;
                };
              };
              if (item.status === 1) {
                if (this.userInfo.selectHouseType === 1 || this.userInfo.selectHouseType === 4) {
                  this.selectHouseTypeIdArr.forEach(id => {
                    if (id === item.orgTaoTypeId) {
                      item.status = 5;
                    }
                  });
                };
                if (this.userInfo.selectHouseType === 5) {
                  this.$nextTick(() => {
                    const houseTableData = this.$props.householdTableData;
                    if (this.userInfo.selectedTierBuildingHousingArea === 0 || this.userInfo.selectedTierBuildingHousingArea === '' || this.userInfo.selectedTierBuildingHousingArea === null) {
                      // debugger;
                      if (item.buildingProperty == 1) {
                        item.status = 5;
                      };
                    } else {
                      if (this.houseData.housingAttribute === '212' && item.housingAttribute === '212') {
                        item.status = 5;
                      };
                      if (this.houseData.housingAttribute !== '212' && item.buildingProperty === 1 && this.houseData.buildingProperty === 1) {
                        if (Number(houseTableData[0].residualArea) < 45) item.status = 5;
                        if (this.tierBuildingHouseIds.length === 0) {
                          item.status = 5;
                        } else {
                          if (this.tierBuildingHouseIds.indexOf(item.id) === -1) item.status = 5;
                        };
                      };
                      if (this.houseData.housingAttribute !== '212' && item.buildingProperty === 2 && this.houseData.buildingProperty === 2) {
                        if (Number(houseTableData[1].residualArea) < 45) item.status = 5;
                        if (this.highBuildingHouseIds.length === 0) {
                          item.status = 5;
                        } else {
                          if (this.highBuildingHouseIds.indexOf(item.id) === -1) item.status = 5;
                        };
                      };
                    }
                  });
                };
              };
            };
          });
        });
        this.dialogToggle = false;
      };
    },
    checkHouseInfo(house, selected) {
      this.selectedIds = [];
      this.selectedIds.push(house.id);
      this.houseData = house;
      this.houseData['housingEstateName'] = this.query.housingEstateName;
      this.houseData['houseTypeName'] = house.houseType;
      this.houseData['removable'] = '1';
      this.showAdd = !selected && this.isSelectHouse === 1 && house.status === 1;
      getHousingHouseNumber(this.projectId, house.id).then(res => {
        if (res.code === 0) {
          res.body.houseTypeAttachmentList.forEach(item => {
            const url = decodeURI(`/housing/source/downloadHousingHouseTypeAttachment/${item.id}/${0}`);
            item.imgPreviewURL = url;
          });
          this.imgs = res.body.houseTypeAttachmentList || [];
        };
      });
      const result = [];
      this.dialogContentConfig.forEach(item => {
        const { key } = item;
        const cell = JSON.parse(JSON.stringify(item));
        if (house[key]) {
          cell.value = house[key];
          result.push(cell);
        }
      });
      this.dialogContent.splice(0, this.dialogContent.length, ...result);
      this.dialogToggle = true;
    },
    selectFileNumber(item) {
      this.householdId = item.householdId;
      this.householdCode = item.householdCode;
      this.selectHouseTypeIdArr = [];
      this.$emit('change');
      // this.queryHouseholdIndex();
      this.houseInfo.forEach(floor => {
        floor.flootHouses.forEach(item => {
          if (item.status === 1) {
            item.checked = false;
          } else {
            item.checked = true;
          }
        });
      });
      this.getUnitTree(this.temporaryQuery);
    },
    // 查询公示项目分户档案信息
    queryHouseholdIndex() {
      let params = {
        householdId: this.householdId
      };
      queryHouseholdIndex(this.projectId, params).then(res => {
        if (res) {
          this.userInfo = res.body;
          this.householdId = this.userInfo.householdId;
          res.body.selectHouseMaxCount = isUndef(res.body.selectHouseMaxCount) ? '' : res.body.selectHouseMaxCount;
          // res.body.selectHouseType = 5;
          this.$emit('getData', res.body);
          this.isSelectHouse = this.userInfo.isSelectHouse;
          this.switchResettlementUpperlimit = this.userInfo.switchResettlementUpperlimit;
        }
      });
    },
    // 查询项目所有档案信息
    getFileInformationList() {
      // getFileInformationList(this.projectId).then(res => {
      //   this.fileInformationList = res.body;
      // });
    },

    renderContent(h, { node, data, store }) {
      if (data.usableHousingNum == 0) {
        return (
          <span class="el-tree-node__label">
            <span>{node.label}<span style="color:red">{`（${data.usableHousingNum}）`}</span></span>
          </span>
        );
      } else {
        return (
          <span class="el-tree-node__label">
            <span>{node.label}<span>{`（${data.usableHousingNum}）`}</span></span>
          </span>
        );
      }

    },

    handleOnUseHouseFlag() {
      this.forTheMomentFlag = true
    },

    handleOffUseHouseFlag() {
      this.forTheMomentFlag = false

    },

    handlePopShow() {
      this.popShowDisable = true;
      const onlySeekSelect = getSession('onlySeekSelect')
      if (onlySeekSelect) {
        const { houseBtnList, startArea, endArea, forTheMomentFlag } = onlySeekSelect
        this.houseBtnList = houseBtnList
        this.startArea = startArea
        this.endArea = endArea
        this.forTheMomentFlag = forTheMomentFlag
        this.useHouseFlag = forTheMomentFlag
      } else {
        this.useHouseFlag = true;
        this.forTheMomentFlag = true;
        this.startArea = undefined;
        this.endArea = undefined;
        const arr = this.$props.totalhouseTypeList
        if (this.houseBtnList.length === 0) {
          this.houseBtnList = arr.map(item => {
            return { ...item, isUse: false }
          })
        } else {
          const arr = this.houseBtnList
          arr.forEach(item => {
            item.isUse = false
          })
          this.houseBtnList = arr
        }
      }

    },

    handleClickIsUse(item) {
      const arr = this.houseBtnList
      arr.forEach(items => {
        if (items.id === item.id) {
          items.isUse = !item.isUse
        }
      })
      this.houseBtnList = arr
    },

    handleReset() {
      this.useHouseFlag = true;
      this.forTheMomentFlag = true;
      this.startArea = undefined;
      this.endArea = undefined;
      const arr = this.houseBtnList;
      arr.forEach(items => {
        items.isUse = false
      })
      this.houseBtnList = arr;
      this.temporaryQuery = {}
      removeSession('onlySeekSelect')
    },

    handleSeek() {
      const arr = this.houseBtnList
      const houseTypeIds = arr.filter(item => item.isUse).map(items => items.id).join('_')
      let startArea = this.startArea
      let endArea = this.endArea
      if (startArea - endArea > 0) {
        startArea = this.endArea
        endArea = this.startArea
      }
      const obj = {
        startArea,
        endArea,
        houseTypeIds
      }
      this.useHouseFlag = this.forTheMomentFlag
      this.temporaryQuery = obj
      this.popShowDisable = false
      const onlyObj = {
        startArea: this.startArea,
        endArea: this.endArea,
        houseBtnList: this.houseBtnList,
        forTheMomentFlag: this.forTheMomentFlag
      }
      setSession('onlySeekSelect', onlyObj)
      this.getUnitTree(obj)
    }
  }
};
</script>
<style scoped lang="less">
.housingResource {
  width: 100%;
  height: 100%;
  // display: flex;
  // flex-direction: column;
  .house-type-img {
    margin-left: 55px;
    display: block;
    width: 400px;
    height: 340px;
  }
  .house-info-p {
    line-height: 30px;
    font-size: 14px;
  }
  .header {
    position: relative;
    height: 50px;
    line-height: 50px;
    // display: flex;
    // align-items: center;
    padding-left: 20px;
    font-size: 14px;
    border-bottom: 1px solid #e4e7ed;
    .name {
      padding-left: 4px;
      font-size: 16px;
      color: #409eff;
      width: 160px;
      display: inline-block;
      vertical-align: top;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .explain {
      margin-left: 40px;
      display: inline-block;
      position: relative;
      span {
        vertical-align: top;
      }
      .propertyOwner-span {
        display: inline-block;
        width: 140px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .div {
        position: absolute;
        width: 16px;
        height: 16px;
        top: 17px;
        left: -35px;
        box-sizing: border-box;
      }
      .border {
        border: 1px solid #888;
      }
      .false {
        background: #999999;
      }
      .success {
        background: #377e22;
      }
    }
    .propertyOwner-content {
      margin-left: 10px;
    }
  }
  .personal-box-btn-housingResource {
    position: absolute;
    right: 10px;
    top: 0;
    .el-button--primary {
      background: #025b91 !important;
      color: #ffffff !important;
      background-color: #025b91;
      border-color: #025b91;
    }
    .el-button--primary:hover {
      background-color: #025b91;
      border-color: #025b91;
    }
    .el-button--primary:focus {
      background-color: #025b91;
      border-color: #025b91;
    }
    .el-button.is-disabled {
      color: #c0c4cc !important;
    }
  }
  .housingResourceBody {
    // flex: 1;
    // display: flex;
    height: calc(~"100% - 50px");
    position: relative;
    overflow: hidden;
    .bodyLeft {
      height: 100%;
      width: 190px;
      position: absolute;
      left: 0;
      top: 0;
      box-sizing: border-box;
      border-right: 1px solid #e4e7ed;
      overflow: scroll;
      padding: 10px;
      /deep/.el-tree--highlight-current
        .el-tree-node.is-current
        > .el-tree-node__content {
        color: #409eff;
      }
    }
    .bodyRight {
      height: 100%;
      box-sizing: border-box;
      margin-left: 190px;
      padding: 10px 30px;
      overflow: scroll;
      .wrapper {
        width: 100%;
        // height: 100%;
        .floorInfo {
          position: relative;
          .floor-num {
            width: 100px;
            height: 70px;
            line-height: 70px;
            text-align: center;
            border: 1px solid #e4e7ed;
            position: absolute;
            left: 0;
            top: 0;
            box-sizing: border-box;
          }
          .house-content {
            margin-left: 120px;
          }
          .border {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            // padding: 10px 0;
            align-items: center;
            width: 100px;
            height: 70px;
            border: 1px solid #e4e7ed;
            box-sizing: border-box;
            margin: 0 30px 10px 0;
            .houseNumber {
              font-size: 14px;
            }
          }
          .canClick {
            display: inline-block;
            vertical-align: top;
            cursor: pointer;
            width: 100px;
            height: 70px;
            border: 1px solid #e4e7ed;
            box-sizing: border-box;
            margin: 0 15px 15px 0;
            .houseNumber {
              font-size: 14px;
              text-align: center;
              line-height: 23px;
            }
          }
          .checked {
            border: none;
            background: #377e22;
            color: #fff;
          }
          .checkedhs {
            border: none;
            background: #999999;
            color: #fff;
          }
          .floor-is-empty {
            margin-top: 120px;
            width: 100%;
            text-align: center;
          }
        }
      }
    }
  }
  .houseInfo {
    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      box-sizing: border-box;
      .item {
        flex: 50% 0 0;
        display: flex;
        margin-bottom: 10px;
        .label {
          flex: 110px 0 0;
          text-align: right;
        }
        .value {
          flex: 1;
          padding-left: 4px;
        }
      }
      .flex_1 {
        flex: 100% 0 0;
      }
    }
  }
  .choose-div-box {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .choose-div-child {
      width: 150px;
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      border-radius: 10px;
      cursor: pointer;
    }
    .child-blue {
      border: 1px solid #025b91;
      color: #025b91;
    }
    .child-orange {
      border: 1px solid #ff6633;
      color: #ff6633;
    }
  }
}
.popover-box {
  max-height: 300px;
  overflow: auto;
  margin-bottom: 10px;
  .popover-box-item {
    margin-bottom: 10px;
  }
}
.popover-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  .footer-reset {
    cursor: pointer;
    padding: 10px 50px;
    height: 15px;
    line-height: 15px;
    text-align: center;
    color: #fff;
    border-radius: 20px 0 0 20px;
    background-color: #409eff;
  }
  .footer-sure {
    cursor: pointer;
    padding: 10px 50px;
    height: 15px;
    line-height: 15px;
    text-align: center;
    color: #fff;
    border-radius: 0 20px 20px 0;
    background-color: #025b91;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/project-system/see/components/housingResource.vue